import React from 'react';
import { Shield, Phone, Mail, Send } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white text-black py-16 border-t border-neutral-100" data-id="element-79">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl" data-id="element-80">
        <div className="grid md:grid-cols-4 gap-12 mb-16" data-id="element-81">
          <div className="col-span-1 md:col-span-2" data-id="element-82">
            <div className="flex items-center gap-3 mb-6" data-id="element-83">
              <Shield className="h-6 w-6 text-black" data-id="element-84" />
              <span className="font-bold text-xl tracking-tight" data-id="element-85">
                Військовий Адвокат
              </span>
            </div>
            <p className="text-sm text-neutral-500 leading-relaxed max-w-xs mb-8" data-id="element-86">
              Професійна юридична допомога військовослужбовцям та їх родинам.
              Захист прав у справах ТЦК, ВЛК та СЗЧ.
            </p>

            {/* Quick contact */}
            <div className="flex flex-col gap-3" data-id="element-87">
              <a href="tel:+380633540689" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors group" data-id="element-88">
                <Phone className="h-4 w-4 group-hover:animate-pulse" data-id="element-89" />
                +380 63 354 06 89
              </a>
              <a href="https://t.me/GurinenkoKarina" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors group" data-id="element-90">
                <Send className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" data-id="element-91" />
                @GurinenkoKarina
              </a>
              <a href="mailto:igorvyshnevyy@gmail.com" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors" data-id="element-92">
                <Mail className="h-4 w-4" data-id="element-93" />
                igorvyshnevyy@gmail.com
              </a>
            </div>
          </div>

          <div data-id="element-94">
            <h4 className="font-bold mb-6 text-sm uppercase tracking-wider" data-id="element-95">
              Навігація
            </h4>
            <ul className="space-y-3 text-sm text-neutral-500" data-id="element-96">
              <li data-id="element-97">
                <a href="#about" className="hover:text-black transition-colors hover:translate-x-1 inline-block transition-transform" data-id="element-98">
                  Про компанію
                </a>
              </li>
              <li data-id="element-99">
                <a href="#services" className="hover:text-black transition-colors hover:translate-x-1 inline-block transition-transform" data-id="element-100">
                  Послуги
                </a>
              </li>
              <li data-id="element-101">
                <a href="#why-us" className="hover:text-black transition-colors hover:translate-x-1 inline-block transition-transform" data-id="element-102">
                  Переваги
                </a>
              </li>
              <li data-id="element-103">
                <a href="#faq" className="hover:text-black transition-colors hover:translate-x-1 inline-block transition-transform" data-id="element-104">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-105">
            <h4 className="font-bold mb-6 text-sm uppercase tracking-wider" data-id="element-106">
              Контакти
            </h4>
            <ul className="space-y-3 text-sm text-neutral-500" data-id="element-107">
              <li data-id="element-108">
                <a href="tel:+380633540689" className="hover:text-black transition-colors" data-id="element-109">
                  +380 63 354 06 89
                </a>
              </li>
              <li data-id="element-110">
                <a href="mailto:igorvyshnevyy@gmail.com" className="hover:text-black transition-colors" data-id="element-111">
                  igorvyshnevyy@gmail.com
                </a>
              </li>
              <li data-id="element-112">м. Київ, вул. Хрещатик, 1</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-100 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-neutral-400" data-id="element-113">
          <p data-id="element-114">© {new Date().getFullYear()} Всі права захищено.</p>
          <div className="flex gap-8" data-id="element-115">
            <a href="#" className="hover:text-black transition-colors" data-id="element-116">
              Політика конфіденційності
            </a>
            <a href="#" className="hover:text-black transition-colors" data-id="element-117">
              Умови використання
            </a>
          </div>
        </div>
      </div>
    </footer>;
}